import { memo, useMemo } from "react"
import styled from "styled-components"
import { Colors } from "themes/palette"
import BodyText from "components/Typography/BodyText"
import CreateApiMappingButton from "./CreateApiMappingButton"

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 48px 24px 0px 44px;
  height: 540px;
  width: 90%;
  background-color: ${Colors.white_alt_soft};
  box-shadow: 0px 2px 10px 0px ${Colors.black_alt_soft};
  border-radius: 12px;
`

const ContainerBox = styled.div`
  display: flex;
  flex-direction: column;
  gap: 60px;
  justify-items: center;
  align-items: center;

  div {
    justify-content: center;
  }
`

interface ApiMappingBoardProps {
  filterValue: string
}

const ApiMappingBoard = (props: ApiMappingBoardProps) => {
  const { filterValue } = props

  const label = useMemo(() => {
    if (filterValue) return "Você ainda não criou nenhum Endpoint para esse produto"

    return "Você ainda não criou nenhum Endpoint"
  }, [filterValue])

  return (
    <Container>
      <ContainerBox>
        <BodyText weight="semi-bold" size="medium" color="gray-dark">
          {label}
        </BodyText>
        <CreateApiMappingButton title="Criar Endpoint" />
      </ContainerBox>
    </Container>
  )
}

export default memo(ApiMappingBoard)
